import { render, staticRenderFns } from "./Databases.vue?vue&type=template&id=7d4865b3&scoped=true"
import script from "./Databases.vue?vue&type=script&lang=js"
export * from "./Databases.vue?vue&type=script&lang=js"
import style0 from "./Databases.vue?vue&type=style&index=0&id=7d4865b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4865b3",
  null
  
)

export default component.exports